module.exports = __webpack_public_path__ + "static/forecrorganikoturum-ff789c17b2abfa9e9ecea8e1af766111.png";